<template>
  <div class="flex overflow-hidde">
    <div class="h-full w-full relative overflow-y-auto">
      <main>
        <div
          class="w-full grid grid-cols-1 xl:grid-cols-2 2xl:grid-cols-3 gap-4"
        >
          <certifications-expired
            v-if="
              checkIfUserIsAuthorized(
                'certifications',
                'providers',
                'agro_exporter'
              )
            "
            :agro_exporter_id="this.userEntityId('agro_exporter')"
          />
          <container-incomes
            v-if="
              checkIfUserIsAuthorized(
                'finances',
                'container_incomes',
                'agro_exporter'
              )
            "
            :agro_exporter_id="this.userEntityId('agro_exporter')"
          />
          <container-outcomes
            v-if="
              checkIfUserIsAuthorized(
                'finances',
                'container_outcomes',
                'agro_exporter'
              )
            "
            :agro_exporter_id="this.userEntityId('agro_exporter')"
          />
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import CertificationsExpired from "@/components/views/dashboard/agro_exporter/CertificationsExpired.vue";
import ContainerIncomes from "@/components/views/dashboard/agro_exporter/ContainerIncomes.vue";
import ContainerOutcomes from "@/components/views/dashboard/agro_exporter/ContainerOutcomes.vue";

export default {
  name: "DashboardAgroExporter",
  components: { CertificationsExpired, ContainerIncomes, ContainerOutcomes }
};
</script>
